import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Smart redirect component that preserves query parameters from URL
 *
 * Handles the case where query params are before the hash (e.g., ?lang=de#/)
 * and moves them to after the hash (e.g., #/locations?lang=de)
 * Also cleans up the URL by removing query params before the hash
 */
const SmartRedirect = ({ to }) => {
  // Check for query parameters before the hash (window.location.search)
  const urlParams = new URLSearchParams(window.location.search);
  const langFromUrl = urlParams.get('lang');

  // Also check in hash (for HashRouter)
  const hash = window.location.hash;
  const hashQueryStart = hash.indexOf('?');
  let langFromHash = null;

  if (hashQueryStart !== -1) {
    const hashQuery = hash.substring(hashQueryStart + 1);
    const hashParams = new URLSearchParams(hashQuery);
    langFromHash = hashParams.get('lang');
  }

  // Prefer language from URL query string, fallback to hash
  const lang = langFromUrl || langFromHash;

  // Build redirect path with language parameter if present
  let redirectTo = to;
  if (lang) {
    const separator = to.includes('?') ? '&' : '?';
    redirectTo = `${to}${separator}lang=${lang}`;
  }

  // Clean up URL: remove query params before hash if they exist
  useEffect(() => {
    if (window.location.search) {
      // Remove query string before hash by replacing URL
      const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  return <Navigate to={redirectTo} replace />;
};

export default SmartRedirect;
